import type { HttpClient } from '~/shared/api'
import { LandingsMainService } from './LandingsMainService'
import { LandingsFormsService } from './LandingsFormsService'

export { default as LandingFeedbackForm } from './LandingFeedbackForm'

export class LandingsService {
  readonly main: LandingsMainService
  readonly forms: LandingsFormsService

  constructor(http: HttpClient) {
    this.main = new LandingsMainService(http)
    this.forms = new LandingsFormsService(http)
  }
}
